/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

export type {
  LoggerProviderConfig,
  LogRecordLimits,
  BufferConfig,
  BatchLogRecordProcessorBrowserConfig,
} from './types';
export { LoggerProvider } from './LoggerProvider';
export type { SdkLogRecord } from './export/SdkLogRecord';
export type { LogRecordProcessor } from './LogRecordProcessor';
export type { ReadableLogRecord } from './export/ReadableLogRecord';
export { ConsoleLogRecordExporter } from './export/ConsoleLogRecordExporter';
export type { LogRecordExporter } from './export/LogRecordExporter';
export { SimpleLogRecordProcessor } from './export/SimpleLogRecordProcessor';
export { InMemoryLogRecordExporter } from './export/InMemoryLogRecordExporter';
export { BatchLogRecordProcessor } from './platform';
